import { render, staticRenderFns } from "./FeFilePreview.vue?vue&type=template&id=6c939aee&scoped=true&"
import script from "./FeFilePreview.vue?vue&type=script&lang=js&"
export * from "./FeFilePreview.vue?vue&type=script&lang=js&"
import style0 from "./FeFilePreview.vue?vue&type=style&index=0&id=6c939aee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c939aee",
  null
  
)

export default component.exports